<template>
  <div
    class="
      flex flex-col
      justify-center
      bg-vice-light-grey
      rounded-lg
      text-center
      px-9
      py-8
      w-full
      max-w-2xl
    "
  >
    <h1 class="text-vice-teal-900 text-xl font-bold pb-3">Network connection changed</h1>
    <p class="text-vice-teal-900 text-base font-medium leading-6 mx-auto mb-5 max-w-xl">
      Reloading the page to reconnect the chat in {{ countdown }}...
    </p>
  </div>
</template>

<script>
export default {
  props: {
    countdown: {
      type: Number,
      required: true,
    },
  },
};
</script>
